import { textAtomTypeId } from '@/enums';
import { useSceneTextSave } from './useSceneTextSave';

/** The plot («Сюжет») row — mirrors `useUpdateSceneLogline` (#1835). */
export function useUpdateSceneSynopsis() {
    return useSceneTextSave({ action: 'updateSynopsis', typeId: textAtomTypeId.scene_synopsis });
}
